function formatProducts(products) {
  return (
    (products &&
      products.map((product) => ({
        id: product.id,
        parentId: (product.parent && product.parent.id) || null,
        name: product.name,
        variantCount: 1,
        image:
          (product.parent && product.parent.images[0].url) ||
          product.images[0].url,
        totalVariants:
          (product.parent &&
            product.parent.variants &&
            product.parent.variants.length) ||
          0
      }))) ||
    []
  );
}

export function clubProductVariants(productsWithVariants) {
  return formatProducts(productsWithVariants).reduce((products, selected) => {
    if (selected.parentId) {
      const index = products.findIndex(
        ({ parentId }) => parentId === selected.parentId
      );

      if (index === -1) {
        products.push({
          ...selected,
          selectedIds: [selected.id]
        });
      } else {
        const increment = products[index].variantCount + 1;
        products[index] = {
          ...selected,
          variantCount: increment,
          selectedIds: [...products[index].selectedIds, selected.id]
        };
      }
    } else {
      products.push({ ...selected, selectedIds: [selected.id] });
    }
    return products;
  }, []);
}

export function getShippingRuleRange(min, max, condition) {
  if (condition) {
    if (min && max) {
      if (condition == "Weight") {
        return `${min}-${max} lbs`;
      } else if (condition == "Price") {
        return `$${min}-${max}`;
      } else {
        return `${min}-${max}`;
      }
    } else if (min && !max) {
      if (condition == "Weight") {
        return `${min} lbs and up`;
      } else if (condition == "Price") {
        return `$${min} and up`;
      } else {
        return `${min} and up`;
      }
    } else {
      if (condition == "Weight") {
        return `${max} lbs and below`;
      } else if (condition == "Price") {
        return `$${max} and below`;
      } else {
        return `${max} and below`;
      }
    }
  } else {
    return "All";
  }
}

export const removeEmptyChildren = (list) =>
  list.filter((elem) => elem.children && elem.children.length > 0);


export const parseNetworkError = err => {
  return err.networkError
    ? err.networkError.result.errors[0].message
    : "Sorry! Something went wrong while placing your order. Please try again later.";
};